<template>
  <f7-block inset class="mt-1">
    <div class="data-table sm bordered card">
      <table>
        <thead>
        <tr>
          <th style="width: 33%;" class="text-align-center">XÁC</th>
          <th style="width: 33%;" class="text-align-center">QUA CÒ</th>
          <th class="text-align-center">TRÚNG</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td style="width: 33%;" class="vertical-align-top p-0">
            <ul class="list-style-none mt-1 mb-1 pl-0">
              <template v-for="(o, idx) in item['1c']">
                <li v-if="o.point > 0" :key="`c_1c_${idx}`">
                  <span class="command_type">{{ o.title }}:</span>
                  {{ o.cost_without_rate | numeral('0,0[.]0') }}
                </li>
              </template>
              <template v-for="(o, idx) in item['2c']">
                <li v-if="o.point > 0" :key="`c_2c_${idx}`">
                  <span class="command_type">{{ o.title }}:</span>
                  {{ o.cost_without_rate | numeral('0,0[.]0') }}
                </li>
              </template>
              <template v-for="(o, idx) in item['3c']">
                <li v-if="o.point > 0" :key="`c_3c_${idx}`">
                  <span class="command_type">{{ o.title }}:</span>
                  {{ o.cost_without_rate | numeral('0,0[.]0') }}
                </li>
              </template>
              <template v-for="(o, idx) in item['4c']">
                <li v-if="o.point > 0" :key="`c_4c_${idx}`">
                  <span class="command_type">{{ o.title }}:</span>
                  {{ o.cost_without_rate | numeral('0,0[.]0') }}
                </li>
              </template>
            </ul>
          </td>
          <td style="width: 33%;" class="vertical-align-top p-0">
            <ul class="list-style-none mt-1 mb-1 pl-0">
              <template v-for="(o, idx) in item['1c']">
                <li v-if="o.point > 0" :key="`cc_1c_${idx}`">
                  <span class="command_type">{{ o.title }}:</span>
                  {{ o.cost | numeral('0,0[.]0') }}
                </li>
              </template>
              <template v-for="(o, idx) in item['2c']">
                <li v-if="o.point > 0" :key="`cc_2c_${idx}`">
                  <span class="command_type">{{ o.title }}:</span>
                  {{ o.cost | numeral('0,0[.]0') }}
                </li>
              </template>
              <template v-for="(o, idx) in item['3c']">
                <li v-if="o.point > 0" :key="`cc_3c_${idx}`">
                  <span class="command_type">{{ o.title }}:</span>
                  {{ o.cost | numeral('0,0[.]0') }}
                </li>
              </template>
              <template v-for="(o, idx) in item['4c']">
                <li v-if="o.point > 0" :key="`cc_4c_${idx}`">
                  <span class="command_type">{{ o.title }}:</span>
                  {{ o.cost | numeral('0,0[.]0') }}
                </li>
              </template>
            </ul>
          </td>
          <td class="vertical-align-top p-0">
            <ul class="list-style-none mt-1 mb-1 pl-0">
              <template v-for="(o, idx) in item['1c']">
                <li v-if="o.point > 0" :key="`ccc_1c_${idx}`">
                  <span class="command_type">{{ o.title }}:</span>
                  {{ o.win_without_win_rate | numeral('0,0[.]0') }}
                </li>
              </template>
              <template v-for="(o, idx) in item['2c']">
                <li v-if="o.point > 0" :key="`ccc_2c_${idx}`">
                  <span class="command_type">{{ o.title }}:</span>
                  {{ o.win_without_win_rate | numeral('0,0[.]0') }}
                </li>
              </template>
              <template v-for="(o, idx) in item['3c']">
                <li v-if="o.point > 0" :key="`ccc_3c_${idx}`">
                  <span class="command_type">{{ o.title }}:</span>
                  {{ o.win_without_win_rate | numeral('0,0[.]0') }}
                </li>
              </template>
              <template v-for="(o, idx) in item['4c']">
                <li v-if="o.point > 0" :key="`ccc_4c_${idx}`">
                  <span class="command_type">{{ o.title }}:</span>
                  {{ o.win_without_win_rate | numeral('0,0[.]0') }}
                </li>
              </template>
            </ul>
          </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th colspan="3">
            <span>【{{ customerType === 1 ? 'Khách' : 'Chủ' }}】</span>
            <span :class="{'text-color-forestgreen': item.result >= 0, 'text-color-crimson': item.result < 0}">{{ item.result >= 0 ? 'Thu' : 'Bù' }}</span>
            <span :class="{'text-color-forestgreen': item.result >= 0, 'text-color-crimson': item.result < 0}">: {{ item.result_line_percent | numeral('0,0[.]0') }} </span>
            <p class="text-align-right" :class="{'text-color-forestgreen': item.result >= 0, 'text-color-crimson': item.result < 0}">
                    <f7-link external :href="`${save_report_image}`">
                      <f7-icon size="16" f7="camera"></f7-icon>
                    </f7-link>
                    <f7-link class="margin-left-half" @click.prevent="copyReport">
                      <f7-icon size="16" f7="doc_on_doc"></f7-icon>
                    </f7-link>
                  </p>
          </th>
        </tr>
        </tfoot>
      </table>
    </div>
  </f7-block>
</template>
<script>
import numeral from "numeral";

export default {
  props: {
    item: Object,
    customerType: Number,
    drawDate: String,
    region: String,
    playStyle: String
  },
  computed: {
    save_report_image() {
      let result_str_color = this.item.result >= 0 ? 'green' : 'red';
      let result_str = this.item.result >= 0 ? 'Thu: ' : 'Bù: ';
      let customer_name = this.customerType === 2 ? 'Chủ' : 'Khách';
      result_str += numeral(this.item.result_total_percent).format('0,0[.]0');

      let region_str = encodeURIComponent(' (' + this.title_play_style(this.region, '') + ')');
      let link = process.env.VUE_APP_API_URL + `misc/generate-summary-img?drawdate=${this.drawDate}%20${region_str}&customer_name=${customer_name}&result_str=${result_str}&result_str_color=${result_str_color}&`;

      _.forOwn(this.item['1c'], (o, key) => {
        if (o.point > 0) {
          link += 'row[]=' + encodeURIComponent(o.title) + '|' + numeral(o.cost_without_rate).format('0,0[.]0') + '|' + numeral(o.cost).format('0,0[.]0') + '|' + numeral(o.win_without_win_rate).format('0,0[.]0') + '&'
        }
      });

      _.forOwn(this.item['2c'], (o, key) => {
        if (o.point > 0) {
          link += 'row[]=' + encodeURIComponent(o.title) + '|' + numeral(o.cost_without_rate).format('0,0[.]0') + '|' + numeral(o.cost).format('0,0[.]0') + '|' + numeral(o.win_without_win_rate).format('0,0[.]0') + '&'
        }
      });

      _.forOwn(this.item['3c'], (o, key) => {
        if (o.point > 0) {
          link += 'row[]=' + encodeURIComponent(o.title) + '|' + numeral(o.cost_without_rate).format('0,0[.]0') + '|' + numeral(o.cost).format('0,0[.]0') + '|' + numeral(o.win_without_win_rate).format('0,0[.]0') + '&'
        }
      });

      _.forOwn(this.item['4c'], (o, key) => {
        if (o.point > 0) {
          link += 'row[]=' + encodeURIComponent(o.title) + '|' + numeral(o.cost_without_rate).format('0,0[.]0') + '|' + numeral(o.cost).format('0,0[.]0') + '|' + numeral(o.win_without_win_rate).format('0,0[.]0') + '&'
        }
      });

      if (navigator.userAgent.indexOf('KOS') >= 0 || navigator.userAgent.indexOf('KTS') >= 0 || navigator.userAgent === '') {
        return 'savethisimage://?url=' + link;
      }

      return link;
    }
  },
  methods: {
    copyReport() {
      let content = `KT SỐ - ${this.drawDate}\n`;

      content += this.title_play_style(this.region, this.playStyle) + ' | ';
      content += this.customerType === 2 ? "Chủ\n" : "Khách\n";

      _.forOwn(this.item['1c'], (o, key) => {
        if (o.point > 0) {
          content += o.title + ': ';
          content += numeral(o.cost_without_rate).format('0,0[.]0') + ' | ';
          content += 'Trúng: ';
          content += numeral(o.win_without_win_rate).format('0,0[.]0') + "\n";
        }
      });

      _.forOwn(this.item['2c'], (o, key) => {
        if (o.point > 0) {
          content += o.title + ': ';
          content += numeral(o.cost_without_rate).format('0,0[.]0') + ' | ';
          content += 'Trúng: ';
          content += numeral(o.win_without_win_rate).format('0,0[.]0') + "\n";
        }
      });

      _.forOwn(this.item['3c'], (o, key) => {
        if (o.point > 0) {
          content += o.title + ': ';
          content += numeral(o.cost_without_rate).format('0,0[.]0') + ' | ';
          content += 'Trúng: ';
          content += numeral(o.win_without_win_rate).format('0,0[.]0') + "\n";
        }
      });

      _.forOwn(this.item['4c'], (o, key) => {
        if (o.point > 0) {
          content += o.title + ': ';
          content += numeral(o.cost_without_rate).format('0,0[.]0') + ' | ';
          content += 'Trúng: ';
          content += numeral(o.win_without_win_rate).format('0,0[.]0') + "\n";
        }
      });

      content += 'TC ';
      content += this.item.result >= 0 ? 'Thu ' : 'Bù ';
      content += ': ' + numeral(this.item.result_total_percent).format('0,0[.]0');

      this.$copyText(content.trimEnd());
      this.showToastBottom('Đã copied');
    },
    showToastBottom(text) {
      const self = this;
      if (!self.toastBottom) {
        self.toastBottom = self.$f7.toast.create({
          text: text,
          closeTimeout: 2000,
        });
      }
      self.toastBottom.open();
    },
  }
}
</script>
<style scoped>
.position-right {
  position : absolute;
  right    : 5px;
}</style>
